import 'paper-css/paper.css';
import '../stylesheets/admin_print.scss';

import Chart from 'chart.js/auto';
import Color from 'color';

function init(){
  Chart.defaults.font.size = 11;
  Chart.defaults.font.family = 'Noto Sans JP';
  Chart.defaults.color = '#000';
  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      }
    },
  }

  Array.from(document.getElementsByClassName('chart')).forEach((d, index) => {
    const color = Color('#2862A3').rotate(360.0 * index / 3);
    const c = JSON.parse(d.dataset.config);
    const config = {
      ...c,
      data: {
        ...c.data,
        datasets: c.data.datasets.map((d, i, a) => (
          {
            data: d.data.map((dd) => (dd == null ? undefined : dd)),
            backgroundColor: color.rotate(360.0 * i / a.length).hex(),
            ...d,
          }
        ))
      },
      options: {
        ...options,
        ...c.options,
        scales: {
          ...c.options.scales,
          x: {
            ticks: {
              callback: function(_value, index, values) {
                return (values.length - index - 1) % 7 === 0 ? c.data.labels[index] : null;
              }
            }
          }
        }
      }
    };
    new Chart(d, config);
  });
}

document.addEventListener("DOMContentLoaded", init);
document.addEventListener("turbolinks:load", init);
